import React, { useRef, useState, useEffect } from "react";
import cssClasses from "../AllAllotments.module.css";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { TabContext, TabPanel } from "@mui/lab";
import TabsMenu from "../../../Subcomponents/TabsMenu";
import TagPending from "./TagPending";
import ChangeAV from "./ChangeAV";
import UpdateSDR from "./UpdateSDR";
import ApprovalPending from "./ApprovalPending";
import Cancellations from "./Cancellations";
import { useSelector } from "react-redux";
import CompletedCrm from "./CompletedCrm";
import Agreement from "./Agreement";
import ParkingSelection from "./ParkingSelection";

const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

function CrmAllotment() {
  const tab = sessionStorage.getItem("tab");
  const classes = useStyles();
  const loggedInUser = useSelector((state) => state.Auth.user);

  const [subTabs, setSubTabs] = useState([]);

  useEffect(() => {
    console.log("loggedInUser -> ", loggedInUser);
    if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]) {
      let _tabs = [];

      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Tag Pending"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Tag Pending",
          value: "Tag Pending",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Change AV"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Change AV",
          value: "Change AV",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Update SDR"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Update SDR",
          value: "Update SDR",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Changed Plan"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Approval Pending",
          value: "Changed Plan",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Parking Selection"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Parking Selection",
          value: "Parking Selection",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Agreement"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Agreement",
          value: "Agreement",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Completed"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Completed",
          value: "Completed",
          isSelected: false,
        });
      }
      if (
        loggedInUser?.roleId?.level == 1 ||
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Cancellations"
        ]?.isAccessible
      ) {
        _tabs.push({
          text: "Cancellations",
          value: "Cancellations",
          isSelected: false,
        });
      }
      if (_tabs.length > 0) {
        _tabs[0].isSelected = true;
      }
      setSubTabs([..._tabs]);
      console.log("SubTabs", subTabs);
    }
  }, [loggedInUser]);
  useEffect(() => {
    console.log(tab);
    if (tab?.includes("change-plan")) {
      setSubTabs((pre) => {
        pre.forEach((ele) => {
          if (ele.value === "Changed Plan") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });
    }
    //   else{setSubTabs((pre) => {
    //     pre.forEach((ele) => {
    //       if (ele.value === "Tag Pending") {
    //         ele.isSelected = true;
    //       } else {
    //         ele.isSelected = false;
    //       }
    //     });
    //     return [...pre];
    //   });
    // }
  }, [tab]);

  return (
    <>
      <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
        <TabContext value={subTabs.find((f) => f?.isSelected)?.value}>
          <TabsMenu
            selectedColor={"#1570EF"}
            selectedBackgroundColor={"#FFFFFF"}
            stylesForTab={{
              color: "#344054",
              fontSize: "1.6rem",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "2.4rem",
              padding: "0.8rem 1.2rem",
              textTransform: "unset",
              borderBottom: "1px solid #EAECF0",
            }}
            borderColor={"#1570EFs"}
            stylesForWrapper={{
              padding: "1.5rem 0",
              background: "#FFFFFF",
            }}
            list={subTabs}
            value={subTabs.find((f) => f?.isSelected)?.value}
            handleChange={(e, value) => {
              sessionStorage.setItem("tab", null);
              setSubTabs((pre) => {
                pre.forEach((ele) => {
                  if (ele.value === value) {
                    ele.isSelected = true;
                  } else {
                    ele.isSelected = false;
                  }
                });
                return [...pre];
              });
            }}
          />
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Tag Pending"}
            index={0}
          >
            <TagPending />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Change AV"}
            index={1}
          >
            <ChangeAV />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Update SDR"}
            index={1}
          >
            <UpdateSDR />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Changed Plan"}
            index={2}
          >
            <ApprovalPending />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Agreement"}
            index={2}
          >
            <Agreement />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Parking Selection"}
            index={2}
          >
            <ParkingSelection />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Completed"}
            index={3}
          >
            <CompletedCrm />
          </TabPanel>
          <TabPanel
            style={{
              height: "calc(100% - 7rem)",
              padding: "0rem 0rem 2rem 1rem !important",
            }}
            className={classes.Tabs}
            value={"Cancellations"}
            index={3}
          >
            <Cancellations />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}

export default CrmAllotment;